var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-layout__wrapper"},[_c('amp-header'),_vm._v(" "),_c('div',{staticClass:"amp-layout__content-container"},[_c('nuxt')],1),_vm._v(" "),_c('a-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }